<template>
  <div class="new-application">
    <el-card class="box-card">
      <div class="back" v-if="isShow">
        <i class="el-icon-back" @click="back"></i>
      </div>
      <div class="content-title">
        <span class="title-icon"></span>
        <span class="title-details">基本信息</span>
      </div>
      <div>
        <dynamic-form
          labelWidth="110px"
          :formConfig="formConfig"
          v-model="form"
          :showBtn="!isShow"
          :showSaveBtn="!isShow"
          :disabled="isShow"
          @save="save(1)"
          @submit="submit(2)"
          @cancelForm="cancel"
          @getContent="getContent"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
  import "@/components/dynamic-form"
  import { addApplication, updateApplication, ApplicationDetails, getSkillRank } from "@/api/bill/ResourceApplication"
  import { deepClone } from "@/utils"
  import { getDocumentCode } from '@/views/utils'

  export default {
    name: "NewApplication",

    data() {
      return {
        id: "",
        form: { saturated: 'Y' },
        formConfig: {
          formItemList: [
            {
              type: "input",
              key: "code",
              label: "单据编号",
              value: "",
              span: 8,
              disabled: true
            },
            {
              label: "项目号",
              key: "project",
              type: "databox",
              placeholder: "请选择项目",
              span: 8,
              props: {
                label: "code",
                value: "code"
              },
              url: '/resourceApply/getProject',
              tableColumn: [
                {
                  property: "code",
                  label: "项目号",
                  align: "center",
                  query: {
                    type: "input"
                  }
                },
                {
                  property: "name",
                  label: "名称",
                  align: "center",
                  query: {
                    type: "input"
                  }
                }
              ],
              extendParms: {queryFieldItem: "id,number,name"},
              multiple: false,
              rules: {
                required: true,
                message: "不能为空",
                trigger: "change"
              }
            },
            {
              label: "项目名",
              key: "projectName",
              type: "input",
              span: 8,
              disabled: true
            },
            {
              label: "人员",
              key: "person",
              type: "databox",
              placeholder: "请选择人员",
              span: 8,
              props: {
                label: "name",
                value: "id"
              },
              url: '/resourceApply/getPerson',
              tableColumn: [
                {
                  property: "name",
                  label: "名称",
                  align: "center",
                  query: {
                    type: "input"
                  }
                }
              ],
              extendParms: {queryFieldItem: "id,number,name"},
              multiple: false,
              rules: {
                required: true,
                message: "不能为空",
                trigger: "change"
              }
            },
            {
              type: "input",
              key: "personCode",
              label: "工号",
              placeholder: "请输入工号",
              value: "",
              span: 8,
              disabled: true
            },
            // {
            //   type: "databox",
            //   key: "skillType",
            //   label: "技能类型",
            //   placeholder: "请输入技能类型",
            //   disabled: false,
            //   value: "",
            //   span: 8,
            //   props: {
            //     label: "name",
            //     value: "id"
            //   },
            //   tableColumn: [
            //     {
            //       property: "name",
            //       label: "名称",
            //       align: "center",
            //       query: {
            //         type: "input"
            //       }
            //     },
            //     {
            //       property: "remark",
            //       label: "备注",
            //       align: "center",
            //       query: {
            //         type: "input"
            //       }
            //     }
            //   ],
            //   extendParms: { queryFieldItem: "id,name" },
            //   multiple: false,
            //   rules: [
            //     { required: true, message: "技能类型不能为空", trigger: "change" }
            //   ]
            // },
            // {
            //   type: "input",
            //   key: "skillLevelName",
            //   label: "技能等级",
            //   placeholder: "请输入技能等级",
            //   value: "",
            //   span: 8,
            //   disabled: true
            // },
            {
              type: "input",
              key: "personRankName",
              label: "职级",
              placeholder: "请输入职级",
              value: "",
              span: 8,
              disabled: true
            },
            {
              type: "number",
              key: "settlementPrice",
              label: "结算单价",
              placeholder: "请输入结算单价",
              value: "",
              span: 8,
              disabled: true
            },
            {
              type: "date",
              key: "startDate",
              label: "起始日期",
              placeholder: "请选择起始日期",
              value: "",
              span: 8,
              rules: {
                required: true,
                message: "起始日期不能为空",
                trigger: "change"
              },
            },
            {
              type: "date",
              disabled: false,
              key: "endDate",
              label: "结束日期",
              placeholder: "请选择结束日期",
              value: "",
              span: 8,
              rules: {
                required: true,
                message: "结束日期不能为空",
                trigger: "change"
              },
            },
            {
              type: "databox",
              key: "projectRole",
              label: "项目角色",
              disabled: false,
              placeholder: "请输入项目角色",
              span: 8,
              props: {
                label: "name",
                value: "id"
              },
              url: "/bsProjectRoles",
              tableColumn: [
                {
                  property: "name",
                  label: "名称",
                  align: "center",
                  query: {
                    type: "input"
                  }
                },
                {
                  property: "stakeholder",
                  label: "权益方",
                  align: "center",
                  query: {
                    type: "input"
                  }
                },
                {
                  property: "remark",
                  label: "备注",
                  align: "center",
                  query: {
                    type: "input"
                  }
                }
              ],
              extendParms: { queryFieldItem: "id,name" },
              multiple: false,
              rules: {
                required: true,
                message: "项目角色不能为空",
                trigger: "change"
              },
            },
            {
              type: "radio",
              key: "saturated",
              label: "工作饱和度",
              disabled: false,
              span: 8,
              options: [
                {
                  label: "是",
                  value: "Y"
                },
                {
                  label: "否",
                  value: "N"
                }
              ]
            },
            {
              type: "number",
              key: "saturatedRate",
              label: "饱和占比",
              disabled: false,
              placeholder: "请输入饱和占比",
              value: "",
              span: 8
            },
            {
              type: "textarea",
              key: "remark",
              label: "备注",
              disabled: false,
              value: "",
              placeholder: "请输入备注",
              span: 16
            }
          ],
          changeFlag: true,
        },
        // 状态
        status: 0,
        personId: '',
      };
    },
    created() {
      this.id = this.$route.query.id;
      // 判断是否是查看
      const isShow = this.$route.query.isShwo;
      if (this.id) {
        this.getDetail(isShow);
      } else {
        this.form.code = getDocumentCode('ZYSQ')
      }
    },
    computed: {
      isShow() {
        if (this.$route.query && this.$route.query.isShow) {
          return this.$route.query.isShow;
        } else {
          return false;
        }
      }
    },
    watch: {
      'form.saturated': {
        handler(newValue, oldValue) {
          if (newValue !== oldValue) {
            this.formConfig.formItemList.find((item, index) => {
              if (item.key === 'saturatedRate') {
                if (newValue === 'N') {
                  this.formConfig.formItemList[index].rules = [{ required: true, message: '工作不饱和时，饱和占比必填！', trigger: 'change' }]
                  this.formConfig.changeFlag = !this.formConfig.changeFlag
                } else if (newValue === 'Y') {
                  this.formConfig.formItemList[index].rules = []
                  this.formConfig.changeFlag = !this.formConfig.changeFlag
                }
              }
            })
          }
        }
      }
    },
    methods: {
      getContent(val) {
        if (val.key === 'project') {
          this.form.projectNumber = val.value.code
          this.form.projectName = val.value.name
        } else if (val.key === 'person') {
          this.form.personCode = val.value.code
          this.form.personRankName = val.value.rankName
          if (val.value.rankEntity) {
            this.form.personRank = val.value.rankEntity.id
            this.form.settlementPrice = val.value.rankEntity.settlementUnitPrice
          }
          this.personId = val.value.id
          this.form.personId = val.value.id
          this.form.skillType = {}
          this.form.skillLevelName = ''
          this.form.slillLevel = null
          this.getSkillType(val.value.id)
        } else if (val.key === 'skillType') {
          this.handleGetSkillRank(val.value.id)
        }
      },
      handleGetSkillRank(id) {
        getSkillRank({ userId: this.personId, skillTypeId: id}).then(res => {
          if (res.code === 200) {
            this.form.skillLevelName = res.data.name
            this.form.skillLevel = res.data.id
          }
        })
      },
      getSkillType(id) {
        this.formConfig.formItemList.find((item, index) => {
          if (item.key === 'skillType') {
            this.formConfig.formItemList[index].url = `/resourceApply/getSkillType?userId=${id}`
            this.formConfig.changeFlag = !this.formConfig.changeFlag
            return true
          }
        })
      },
      getDetail(isShow) {
        ApplicationDetails(this.id).then(res => {
          if (res.code === 200) {
            const showData = res.data
            showData.person = showData.bsPerson
            showData.skillType = showData.bsSkillsType
            if (showData.bsSkillsLevel) {
              showData.skillLevelName = showData.bsSkillsLevel.name
            }
            showData.personRankName = showData.bsPersonRank.name
            showData.projectRole = showData.bsProjectRoles
            showData.project = { code: showData.projectNumber }
            this.form = showData
            this.getSkillType(showData.personId)
            // 当状态查看时，所有表单不可修改
            if (isShow || isShow === "true") {
              this.formConfig.formItemList.forEach(item => {
                item.disabled = true;
              });
            }
          }
        });
      },
      submit(status) {
        this.status = status;
        this.pull();
      },
      save(status) {
        this.status = status;
        this.pull();
      },
      cancel() {
        this.$router.go(-1);
      },
      back() {
        this.$router.go(-1);
      },
      pull() {
        if (this.id) {
          this.form.startDate = new Date(this.form.startDate).getTime();
          this.form.endDate = new Date(this.form.endDate).getTime();
          const form = deepClone(this.form);
          form.billState = this.status;
          form.skillType = form.skillType.id;
          form.projectRole = form.projectRole.id;
          updateApplication(form).then(res => {
            if (res.code === 200) {
              this.$notify({
                title: "提交成功！",
                type: "success",
                duration: 2500
              });
              this.id = res.data.id;
            }
          });
        } else {
          this.form.startDate = new Date(this.form.startDate).getTime();
          this.form.endDate = new Date(this.form.endDate).getTime();
          const form = deepClone(this.form);
          form.billState = this.status;
          form.skillType = form.skillType.id;
          form.projectRole = form.projectRole.id;
          addApplication(form).then(res => {
            if (res.code === 200) {
              this.$notify({
                title: "提交成功！",
                type: "success",
                duration: 2500
              });
              this.id = res.data.id;
            }
          });
        }
        this.cancel();
      }
    }
  };
</script>

<style lang="scss" scoped>
  .content-title {
    height: 40px;
    // background-color: #e7eff6;
    padding-left: 20px;
    overflow: hidden;
    .title-icon {
      display: inline-block;
      margin-top: 8px;
      width: 4px;
      height: 24px;
      background-color: #1369a8;
      margin-right: 14px;
    }
    .title-details {
      overflow: hidden;
      line-height: 20px;
      display: inline-block;
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      font-family: SourceHanSansSC-regular;
    }
  }
  .el-icon-back {
    padding-bottom: 10px;
  }
</style>
